export const ONLINE_STATE_CHANGED = 'online-state-change';
export const AUTH_STATE_CHANGED = 'auth-state-change';
